var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"#"}},[_c('iframe',{attrs:{"src":_vm.pdf,"type":"application/pdf","download":"stestes","width":"100%","height":"1095px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }